<template>
  <g>
    <path
      d="M20.71 7.98018L16.03 3.30018C15.84 3.11018 15.58 3.00018 15.32 3.00018H8.68C8.42 3.00018 8.16 3.11018 7.98 3.29018L3.29 7.98018C3.11 8.16018 3 8.42018 3 8.68018V15.3102C3 15.5802 3.11 15.8302 3.29 16.0202L7.97 20.7002C8.16 20.8902 8.42 21.0002 8.68 21.0002H15.31C15.58 21.0002 15.83 20.8902 16.02 20.7102L20.7 16.0302C20.89 15.8402 20.99 15.5902 20.99 15.3202V8.68018C21 8.42018 20.89 8.16018 20.71 7.98018ZM19 14.9002L14.9 19.0002H9.1L5 14.9002V9.10018L9.1 5.00018H14.9L19 9.10018V14.9002Z"
    />
    <path
      d="M12 17.0002C12.5523 17.0002 13 16.5525 13 16.0002C13 15.4479 12.5523 15.0002 12 15.0002C11.4477 15.0002 11 15.4479 11 16.0002C11 16.5525 11.4477 17.0002 12 17.0002Z"
    />
    <path
      d="M12 7.00018C11.45 7.00018 11 7.45018 11 8.00018V13.0002C11 13.5502 11.45 14.0002 12 14.0002C12.55 14.0002 13 13.5502 13 13.0002V8.00018C13 7.45018 12.55 7.00018 12 7.00018Z"
    />
  </g>
</template>
